import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class BackorderArticlesComponent {
    constructor() {
        this.componentSelector = "#ecom-backorder-articles";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {

        let instance = this;
        instance.search(instance);

        $('.js-update-article').off().on('click', function () {
            instance.update(instance);
        });

        $('.js-delete-article').off().on('click', function () {
            instance.delete(instance);
        });

        $('#js-add-article').off().on('click', function () {
            instance.showAddModal(instance);
        });
    }

    update(instance) {
        let article = $('#article').val();
        let validfrom = $('#validfrom').val();
        let validto = $('#validto').val();

        axios({
            method: 'post',
            url: "/backorderarticle/UpsertBackorderArticle",
            data: { article: article, validfrom: validfrom, validto: validto }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.search(instance);
            setTimeout("$('#edit-modal').modal('hide');", 10);
        }).catch(function (response) {
            bootbox.alert("Ett fel inträfface.");
        });
    }

    delete(instance) {
        let article = $('#article').val();

        axios({
            method: 'post',
            url: "/backorderarticle/DeleteBackorderArticle",
            data: { article: article }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.search(instance);
            setTimeout("$('#edit-modal').modal('hide');", 10);
        }).catch(function (response) {
            bootbox.alert("Ett fel inträfface.");
        });
    }

    search(instance) {
        axios({
            method: 'post',
            url: "/backorderarticle/BackorderArticles"
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
            bootbox.alert("Ett fel inträffade.");
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Redigera';
        button.addEventListener('click', function () {
            params.context.showModal(params.value, params.data, params.context);
        });
        return button;
    }

    showModal(values, data, instance) {
        $('#article').val(data.ArticleNumber);
        $('#validfrom').val(data.ValidFromFormatted);
        $('#validto').val(data.ValidToFormatted);

        $('.js-delete-discount').show();
        
        setTimeout("$('#edit-modal').modal('show');", 10);
        $('#article').prop("disabled", true);
    }

    showAddModal(data, instance) {
        $('#article').val("");
        $('#validfrom').val(new Date().toJSON().slice(0, 10));
        $('#validto').val("");
        $('.js-delete-article').hide();
        $('#article').prop("disabled", false);

        setTimeout("$('#edit-modal').modal('show');", 10);
        setTimeout("$('#article').focus();", 20);
    }

    render(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    { headerName: 'Artikelnummer', field: 'ArticleNumber' },
                    { headerName: 'Namn', field: 'ArticleName' },
                    { headerName: 'Gäller från', field: 'ValidFromFormatted' },
                    { headerName: 'Gäller till', field: 'ValidToFormatted' },
                    { headerName: 'Skapad', field: 'CreatedFormatted' },
                    {
                        headerName: "",
                        field: 'Data',
                        cellRenderer: instance.buttonRenderer,
                        width: 160,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }


        $('#js-add-discount').show();
    }
}